(function (){
    'use strict';
    angular.module('elogbooks.admin.billing-types', []);
})();
